var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:'mod ' + _vm.mod.modname.toLowerCase() + ' ' + _vm.mod.modclass.toLowerCase(),attrs:{"id":_vm.tag + '-' + _vm.refId}},[_c(_vm.mod.modname,{tag:"component",attrs:{"config":_vm.mod.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }